import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'search',

  type : 'module',
  
  label: 'champs de recherche',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-text-search-variant',
  }
}